<template>
    <div class="design-box">
        <h2 class="child-title AvantGarde">4D DESIGN</h2>
        <h3 class="child-title-cn YaSiBold"></h3>
        <div class="design">
            <div class="left">
                <div class="design-left-1 a1">
                    <h2 class="design-title-h2 AvantGarde">SENSE OF AESTHETICS</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">Speaking of sense of aesthetics, we may think of Hugo Alvar Herik Aalto and furniture he designed, Apple and MP3, Santiago Calatrava and his bridges, and Philippe Starck and household objects. Creating new ways of combining materials, functions, and appearance, their designs have changed our thinking of these things.</p>
                </div>
                <div class="design-left-2 a2">
                    <h2 class="design-title-h2 AvantGarde">VALUE</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">Does it cost higher to build a beautiful house than an ugly one? Of course not. Good design doesn't necessarily cost more than the bad one. Design can touch both on the good look and low cost.</p>
                </div>
            </div>
            <svg class="design-middle-img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297.6 297.6" width="297.6" height="297.6"><path fill="none" stroke="#000" stroke-width="4" stroke-linecap="round" stroke-miterlimit="10" d="M6.6 107.5c13.8-45 48.3-81 92.4-96.9" class="svg-elem-1"/><path fill="none" stroke="#000" stroke-width="4" stroke-linecap="round" stroke-miterlimit="10" d="M100.5 293.2C56.2 277.7 21.3 242 7 197.1" class="svg-elem-2"/><path fill="none" stroke="#000" stroke-width="4" stroke-linecap="round" stroke-miterlimit="10" d="M292.5 198c-14.2 43.8-48 78.7-91 94.4" class="svg-elem-3"/><path fill="none" stroke="#000" stroke-width="4" stroke-linecap="round" stroke-miterlimit="10" d="M203.5 11.7c42.2 16.2 75.2 50.9 89.1 94.1" class="svg-elem-4"/><circle fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" cx="150.1" cy="152.8" r="45.4" class="svg-elem-5"/><path fill="none" stroke="#006284" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" class="svg-elem-6" d="M58.2 67.1l36.7 36.7"/><path fill="none" stroke="#006284" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" class="svg-elem-7" d="M242 67.1l-36.8 36.7"/><path fill="none" stroke="#006284" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" class="svg-elem-8" d="M63.3 238.4l36.7-36.7"/><path fill="none" stroke="#006284" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" class="svg-elem-9" d="M238.3 238.4l-36.7-36.7"/></svg>
            <div class="right">
                <div class="design-right-1 a3">
                    <h2 class="design-title-h2 AvantGarde">FUNCTION</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">Being user-friendly, simple, gook-looking, and artistic makes the essence of Scandinavian Designs. It is also a part of the design to link the practicality of an object with logic and simple lines, and good-looking appearance, and to enhance the function of a product through the application of technology or technological design.</p>
                </div>
                <div class="design-right-2 a4">
                    <h2 class="design-title-h2 AvantGarde">EMOTION</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">You may wonder that you feel something when touching an object, which arouses you to think of yourself, loyalty, and even those old days. When a product comes to influence our thinking on ourselves and the world around us, we start to build an emotional linking with this product.</p>
                </div>
            </div>
            <div class="mobile-box">
                <div class="design-left-1 a1">
                    <h2 class="design-title-h2 AvantGarde">SENSE OF AESTHETICS</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">Speaking of sense of aesthetics, we may think of Hugo Alvar Herik Aalto and furniture he designed, Apple and MP3, Santiago Calatrava and his bridges, and Philippe Starck and household objects. Creating new ways of combining materials, functions, and appearance, their designs have changed our thinking of these things.</p>
                </div>
                <div class="design-right-1 a3">
                    <h2 class="design-title-h2 AvantGarde">FUNCTION</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">Being user-friendly, simple, gook-looking, and artistic makes the essence of Scandinavian Designs. It is also a part of the design to link the practicality of an object with logic and simple lines, and good-looking appearance, and to enhance the function of a product through the application of technology or technological design.</p>
                </div>
                <div class="design-left-2 a2">
                    <h2 class="design-title-h2 AvantGarde">VALUE</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">Does it cost higher to build a beautiful house than an ugly one? Of course not. Good design doesn't necessarily cost more than the bad one. Design can touch both on the good look and low cost.</p>
                </div>
                <div class="design-right-2 a4">
                    <h2 class="design-title-h2 AvantGarde">EMOTION</h2>
                    <h3 class="design-title-h3 YaSiRegular"></h3>
                    <p class="design-p p AvantGarde">You may wonder that you feel something when touching an object, which arouses you to think of yourself, loyalty, and even those old days. When a product comes to influence our thinking on ourselves and the world around us, we start to build an emotional linking with this product.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AboutUsDesign'
    }
</script>

<style lang="scss" scoped>
    @use 'styles/varibles' as *;
    @use 'styles/common' as *;
    .design-box {
        margin: 0 auto 10rem;
        width: 90%;
    }
    .child-title {
        margin: 3.4rem 0 0 0;
        color: $designColor;
        opacity: 0;
    }
    .child-title-cn {
        margin: 1rem 0 5rem 0;
        letter-spacing: 1rem;
        color: $designColor;
        opacity: 0;
    }
    .design {
        display: flex;
        justify-content: space-around;
        padding: 50px 0;
        border-top: 1px solid #e2e2e2;
        border-bottom: 1px solid #e2e2e2;
    }
    .left {
        width: 30%;
        text-align: right;
    }
    .design-middle-img {
        width: 20%;
    }
    .right {
        width: 30%;
        text-align: left;
    }
    .mobile-box {
        display: none;
    }
    .design-left-2,
    .design-right-2,
    {
        margin-top: 20px;
    }
    .design-title-h2 {
        color: $designColor;
    }
    .design-title-h3 {
        margin: 10px 0 10px 0;
    }
    .design-p {
        line-height: 1.6;
    }
    .animate .child-title {
        animation: fadeInUp .3s linear forwards;
    }
    .animate .child-title-cn {
        animation: fadeInUp .3s .3s linear forwards;
    }

    .animate .svg-elem-1 {
        animation: animate-svg-stroke-1 1.5s ease 0s both;
    }
    .animate .svg-elem-2 {
        animation: animate-svg-stroke-2 1.5s ease 0.12s both;
    }
    .animate .svg-elem-3 {
        animation: animate-svg-stroke-3 1.5s ease 0.24s both;
    }
    .animate .svg-elem-4 {
        animation: animate-svg-stroke-4 1.5s ease 0.36s both;
    }
    .animate .svg-elem-5 {
        animation: animate-svg-stroke-5 1.5s ease 0.48s both;
    }
    .animate .svg-elem-6 {
        animation: animate-svg-stroke-6 1.5s ease 0.6s both;
    }
    .animate .svg-elem-7 {
        animation: animate-svg-stroke-7 1.5s ease 0.72s both;
    }
    .animate .svg-elem-8 {
        animation: animate-svg-stroke-8 1.5s ease 0.84s both;
    }
    .animate .svg-elem-9 {
        animation: animate-svg-stroke-9 1.5s ease 0.96s both;
    }
    @for $i from 1 through 4
    {
        .a#{$i}
        {
            opacity: 0;
        }
    }
    @for $i from 1 through 4
    {
        .animate .a#{$i}
        {
            animation: opacityIn 1s #{1000 + 200 * $i}ms linear forwards;
        }
    }
    @keyframes animate-svg-stroke-1 {
        0% {
            stroke-dashoffset: 140.7895050048828px;
            stroke-dasharray: 140.7895050048828px;
        }

        100% {
            stroke-dashoffset: 281.5790100097656px;
        }
    }
    @keyframes animate-svg-stroke-2 {
        0% {
            stroke-dashoffset: 140.96852111816406px;
            stroke-dasharray: 140.96852111816406px;
        }

        100% {
            stroke-dashoffset: 281.9370422363281px;
        }
    }
    @keyframes animate-svg-stroke-3 {
        0% {
            stroke-dashoffset: 137.7076873779297px;
            stroke-dasharray: 137.7076873779297px;
        }

        100% {
            stroke-dashoffset: 275.4153747558594px;
        }
    }
    @keyframes animate-svg-stroke-4 {
        0% {
            stroke-dashoffset: 135.97865295410156px;
            stroke-dasharray: 135.97865295410156px;
        }

        100% {
            stroke-dashoffset: 271.9573059082031px;
        }
    }
    @keyframes animate-svg-stroke-5 {
        0% {
            stroke-dashoffset: 287.2566129459532px;
            stroke-dasharray: 287.2566129459532px;
        }

        100% {
            stroke-dashoffset: 574.5132258919064px;
        }
    }
    @keyframes animate-svg-stroke-6 {
        0% {
            stroke-dashoffset: 53.901641845703125px;
            stroke-dasharray: 53.901641845703125px;
        }

        100% {
            stroke-dashoffset: 107.80328369140625px;
        }
    }
    @keyframes animate-svg-stroke-7 {
        0% {
            stroke-dashoffset: 53.9724006652832px;
            stroke-dasharray: 53.9724006652832px;
        }

        100% {
            stroke-dashoffset: 107.9448013305664px;
        }
    }
    @keyframes animate-svg-stroke-8 {
        0% {
            stroke-dashoffset: 53.901634216308594px;
            stroke-dasharray: 53.901634216308594px;
        }

        100% {
            stroke-dashoffset: 107.80326843261719px;
        }
    }
    @keyframes animate-svg-stroke-9 {
        0% {
            stroke-dashoffset: 53.901634216308594px;
            stroke-dasharray: 53.901634216308594px;
        }

        100% {
            stroke-dashoffset: 107.80326843261719px;
        }
    }
    @media screen and (max-width: 750px) {
        .design {
            padding: 3rem 0;
            border: none;
        }
        .child-title-cn {
            margin: 1rem 0 1rem 0;
        }
        .design-middle-img {
            display: none;
        }
        .left, .right {
            display: none;
        }
        .mobile-box {
            display: block;
        }

        .mobile-box .design-left-1,
        .mobile-box .design-left-2
        {
            text-align: right;
        }
        .mobile-box .design-left-1,
        .mobile-box .design-left-2,
        .mobile-box .design-right-1,
        .mobile-box .design-right-2
        {
            margin-top: 20px;
            padding: 1rem 0;
            border-bottom: 1px solid $designColor;
        }
    }
    @media screen and (max-width: 1440px) {
        .p {
            font-size: 12px;
        }
    }
</style>
